import React, { useMemo, useState } from 'react';
import { Box, Accordion, AccordionSummary, AccordionDetails, Typography, Grid2, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CustomDivider from '../../shared/utils/CustomDivider';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import { useEventApartmentDetail, useEventList} from '../../assets/api/useAdminApi';
import SearchInput from '../../shared/components/student/SearchInput';
import { FilterButton, StatusButton } from '../../shared/utils/IconButton';
import { Constants } from '../../shared/constants';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import { useDialog } from '../../shared/hook/useDialog';
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import EventLinkForm from './EventLinkForm';
import EventListTable from './EventListTable';
import ToggleSwitch from '../../shared/utils/CustomToggle';
const EventList = () => {
    

    const [selectedCategory, setSelectedCategory] = useState('');
    const [courseId, setCourseId] = React.useState(null);
    const [expandedPanel, setExpandedPanel] = React.useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [showActiveOnly, setShowActiveOnly] = useState(true);
    const { open, handleClickOpen, handleClose } = useDialog();
    const { data: eventList, isLoading } = useEventList();
    const { data: eventApartmentDetail, isLoading: isCourseApartmentLoading } = useEventApartmentDetail({ event_id: courseId });
    const handleAccordionChange = (panelId) => (event, isExpanded) => {
        setExpandedPanel(isExpanded ? panelId : null);
        setCourseId(isExpanded ? panelId : null);
    };
    const originalEventRows = useMemo(() => {
        return eventApartmentDetail?.map((item, index) => ({
            sr_no: index + 1,
            ...item
        })) || [];
    }, [eventApartmentDetail]);

    // Filter cities based on search query
    // const filteredCourseRows = useMemo(() => {
    //     if (!searchQuery.trim()) {
    //         return originalEventRows;
    //     }
    //     const lowercasedQuery = searchQuery.toLowerCase();
    //     return originalEventRows.filter(city =>
    //         city?.apartment_name?.toString().toLowerCase().includes(lowercasedQuery)
    //     );
    // }, [originalEventRows, searchQuery]);
    const filteredCourseRows = useMemo(() => {
        if (!searchQuery.trim()) return originalEventRows;
        const lowercasedQuery = searchQuery.toLowerCase();
        return originalEventRows.filter(item =>
            item?.apartment_name?.toLowerCase().includes(lowercasedQuery)
        );
    }, [originalEventRows, searchQuery]);


    const filteredEventList = useMemo(() => {
        if (!eventList) return [];

        let rows = eventList;

        if (selectedCategory) {
            rows = rows.filter(user => user.name === selectedCategory);
        }

        if (showActiveOnly) {
            rows = rows.filter(user => user.status == 1);
        }

        return rows;
    }, [eventList, selectedCategory, showActiveOnly]);
    const handleSearchChange = (value) => {
        setSearchQuery(value);
    };

    const categoryOptions = Array.from(
        new Set(eventList?.map(item => item.name))
    ).map((name, index) => ({
        id: index + 1,
        value: name,
        label: name,
    }));



    const initialValues = {
        category_name: "",
    };

    const validationSchema = Yup.object().shape({});
    const handleSubmit = (values, { resetForm }) => {
        setSelectedCategory(values.category_name);
        handleClose();
        resetForm();
    };
    const handleToggleChange = (isChecked) => {
        setShowActiveOnly(isChecked);
    };

    return (
        <Box>
            <CustomDivider />
            <NormalContainerWithHeader headerText={"Assign Event"} >
                <EventLinkForm />
            </NormalContainerWithHeader>
            <CustomDivider orientation='horizontal' />
            <NormalContainerWithHeader headerText={"Event List"} RightContent={
                <>
                    <ToggleSwitch checked={showActiveOnly} onCheck={handleToggleChange} checkedText="Active" unCheckedText="Active" />
                    <FilterButton
                        bgcolor={"transparent"}
                        border={"0.5px solid #A9B7FD"}
                        src={Constants.customImages.FilterDark}
                        onClick={handleClickOpen}
                    />
                </>

            } >

                <CustomDivider orientation='horizontal' />
                {

                    !isLoading && filteredEventList?.map((item) => (
                        <Accordion
                            key={item?.id}
                            expanded={expandedPanel === item?.id}
                            onChange={handleAccordionChange(item?.id)}
                            sx={{ boxShadow: "none", border: "none" }}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", mr: 2 }}>
                                    <Typography variant='body2' sx={{ display: "flex", alignItems: "center", gap: 1 }}>{item?.title}</Typography>
                                    <StatusButton status={item?.status} />
                                </Box>

                            </AccordionSummary>
                            {expandedPanel === item?.id && (
                                <AccordionDetails>
                                    <Box width={"40%"} marginLeft={"auto"} marginBottom={2}>
                                        <SearchInput onChange={handleSearchChange} placeholder={"Search By Apartment Name"} />
                                    </Box>
                                    <EventListTable eventRow={filteredCourseRows} isLoading={isCourseApartmentLoading} />
                                </AccordionDetails>
                            )}
                        </Accordion>
                    ))}

                {
                    isLoading && [...Array(10)].map((_, index) => (
                        <Box key={index}>
                            <SkeletonCom height={"30px"} style={{ margin: "5px" }} />
                        </Box>
                    ))

                }
            </NormalContainerWithHeader>
            <MainDialogBox open={open} handleClose={handleClose} width={"30%"} heading={"Filter Event"}>
                <Formik initialValues={initialValues} enableReinitialize validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {() => (
                        <Form>
                            <Grid2 container spacing={"20px"}>
                                <Grid2 children size={12}>
                                    <Field
                                        name="category_name"
                                        component={AutoCompleteField}
                                        placeholder="Select Category"
                                        options={categoryOptions}
                                        label="select Category"
                                        isLoading={isLoading}
                                    />
                                </Grid2>

                                <Grid2 children textAlign={"end"} size={12}>
                                    <Button variant='contained' type='submit' fullWidth>Filter</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>
        </Box>
    );
};

export default EventList;
